import { render } from "./ExchangeCards.vue?vue&type=template&id=592ad73b&ts=true"
import script from "./ExchangeCards.vue?vue&type=script&lang=ts"
export * from "./ExchangeCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__